import React, { useEffect, useState } from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { line } from "../../Assets.tsx";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const reviews = [
  {
    img: "https://cdn-icons-png.flaticon.com/512/456/456212.png",
    name: "Atul",
    rating: "⭐️⭐️⭐️⭐️⭐️",
    comment: "Excellent service!",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/512/456/456212.png",
    name: "Affan",
    rating: "⭐️⭐️⭐️⭐️",
    comment: "Very good experience.",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/512/456/456212.png",
    name: "Harshal",
    rating: "⭐️⭐️⭐️⭐️⭐️",
    comment: "Absolutely fantastic!",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/512/456/456212.png",
    name: "Faisal",
    rating: "⭐️⭐️⭐️⭐️⭐️",
    comment: "I liked it a lot.",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/512/456/456212.png",
    name: "Sufiyan",
    rating: "⭐️⭐️⭐️⭐️",
    comment: "I liked it a lot.",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/512/456/456212.png",
    name: "Pratiksha",
    rating: "⭐️⭐️⭐️⭐️⭐️",
    comment: "Highly recommended!",
  },
];

const Card = ({ rating, comment, name, img }) => (
  <>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.google.com/maps/place/Wet%E2%80%99nJoy+Waterpark+%26+Amusement+Park/@18.7625715,73.5092466,17z/data=!4m12!1m2!2m1!1swet+n+joy!3m8!1s0x3bc2abb216646867:0x13c74f32bdfc2c55!8m2!3d18.7625715!4d73.5140102!9m1!1b1!15sCgl3ZXQgbiBqb3laCyIJd2V0IG4gam95kgEKd2F0ZXJfcGFya-ABAA!16s%2Fg%2F1tfpy9fw?entry=ttu"
    >
      <div className="card">
        <div className="rating-img">
          <img
            style={{
              height: "60px",
              border: "1px solid black",
              borderRadius: "50px",
            }}
            src={img}
            alt=""
          />
        </div>
        <div className="name">{name}</div>
        <div className="rating">{rating}</div>
        <div className="comment">"{comment}"</div>
      </div>
    </a>
  </>
);

const Contact = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 3) % reviews.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const cardsToShow = reviews.slice(index, index + 3);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    if (!isMobile) {
      const footerSection2 = gsap.from(".gsapReview", {
        opacity: 0,
        duration: 1,
        x: 500,
        scrollTrigger: {
          trigger: ".gsapReview",
          scroller: "body",
          markers: false,
          start: "top 100%",
        },
      });
      ScrollTrigger.matchMedia({
        "(max-width: 800px)": function () {
          footerSection2.vars.x = 0;
        },
      });
    }
  });

  useGSAP(() => {
    if (!isMobile) {
      const footerSection2 = gsap.from(".gsapReview2", {
        opacity: 0,
        duration: 1,
        x: -500,
        scrollTrigger: {
          trigger: ".gsapReview2",
          scroller: "body",
          markers: false,
          start: "top 100%",
        },
      });
      ScrollTrigger.matchMedia({
        "(max-width: 800px)": function () {
          footerSection2.vars.x = 0;
        },
      });
    }
  });

  return (
    <div style={{ paddingTop: "55px" }}>
      <div
        className="h1_div"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img className="img-size" src={line} alt="" />
        <h1
          style={{
            textAlign: "center",
            fontSize: "40px",
            padding: "26px 0px",
            margin: "0px 20px",
          }}
          className="titlesFontFamily"
        >
          Testinomials
        </h1>
        <img className="img-size" src={line} alt="" />
      </div>
      <div className="App gsapReview">
        <div className="ratingcard-container">
          {cardsToShow.map((review, idx) => (
            <Card
              key={idx}
              rating={review.rating}
              comment={review.comment}
              name={review.name}
              img={review.img}
            />
          ))}
        </div>
      </div>

      <div
        id="Contact"
        className="h1_div"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img className="img-size" src={line} alt="" />
        <h1
          style={{
            textAlign: "center",
            fontSize: "40px",
            padding: "26px 0px",
            margin: "0px 20px",
          }}
          className="titlesFontFamily"
        >
          Contact Us
        </h1>
        <img className="img-size" src={line} alt="" />
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          className="contact"
          style={{
            margin: "20px 0px",
            width: "100%",
            display: "flex",
            justifyContent: "space-evenly",
            flexWrap: "wrap",
          }}
        >
          {/* phone div */}
          <a
            href="tel:+918888769628"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="contactdiv Contactus_div"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "10px",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <PhoneIcon
                  sx={{
                    fontSize: 40,
                    margin: "5px",
                    marginRight: "10px",
                    "&:hover": {cursor: "pointer" },
                  }}
                />
                <h1>Call Us</h1>
              </div>
            </div>
          </a>
          {/* whatsapp div */}
          <a
            href="https://wa.me/8888769628"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="whatsupdiv Contactus_div"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "10px",
                borderRadius: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <WhatsAppIcon
                  sx={{
                    fontSize: 40,
                    margin: "5px",
                    color: "white",
                    marginRight: "10px",
                    backgroundColor: "green",
                    borderRadius: "30%",
                    "&:hover": { cursor: "pointer" },
                  }}
                />
                <h1>Whatsapp Us</h1>
              </div>
            </div>
          </a>

          {/* email div */}
          <a
            href="mailto:eaglevila@gmail.com"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <div
              className="emaildiv Contactus_div"
              style={{
                marginBottom: "10px",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                <EmailIcon
                  sx={{
                    fontSize: 40,
                    margin: "5px",
                    marginRight: "10px",
                    "&:hover": { cursor: "pointer" },
                  }}
                />
                <h1>Email Us</h1>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
